<div class="reset-password-confirm-page-container">
  <app-reset-password-confirm class="z-index--1"></app-reset-password-confirm>
  <app-circles-background class="circle-background"></app-circles-background>
</div>
